import React from "react";
import PropTypes from "prop-types";

import { useGetAdvisors } from "./hooks/useGetAdvisors";
import {
  ControlledTaskAssigneeSelector,
  Placeholder,
  TaskAssigneeSelectorHeader,
} from "./components";

export function ReassignTaskForm({ currentUserId, defaultValue }) {
  const { loading, advisors, currentUser, error } =
    useGetAdvisors(currentUserId);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Placeholder data-test="task-assignee-loader">
          <Placeholder.Header>
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Header>
        </Placeholder>
      </div>
    );
  }

  if (error) {
    return <div data-test="task-loading-error">{error}</div>;
  }

  if (!currentUser?.numOfTasks) {
    return (
      <div>{`${
        currentUser?.name || "This user"
      } does not have any uncompleted tasks to be reassigned.`}</div>
    );
  }

  return (
    <TaskAssigneeSelectorHeader name={currentUser.name}>
      <ControlledTaskAssigneeSelector
        defaultValue={defaultValue}
        users={advisors}
      />
    </TaskAssigneeSelectorHeader>
  );
}

ReassignTaskForm.propTypes = {
  currentUserId: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
};

ReassignTaskForm.defaultProps = {
  defaultValue: "unassigned",
};

export default ReassignTaskForm;
